import '$styles/index.css'

import { session } from '@hotwired/turbo'

// Turbo is used only for the help centre's <turbo-frame id="help-content"> (clicking an
// article swaps just that frame, keeping the left menu). Turbo Drive is left off so it does
// not intercept navigation anywhere else on the marketing site — Turbo Frames work without it.
session.drive = false

import './search'
import 'alpinejs'
import AOS from 'aos'
import Cookies from 'js-cookie'

import { startStimulus } from './controllers/index'

startStimulus()

AOS.init({
  easing: 'ease-in-out-sine',
})

window.Cookies = Cookies
